<template>
  <router-view />
</template>

<script>
export default {
  name: "App",

  data: () => ({}),
};
</script>
<style lang="scss">
html {
  overflow-y: auto !important;
}
.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.pointer {
  cursor: pointer;
}
a:focus-visible,
button:focus-visible,
[role="button"]:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
.v-btn:focus-visible,
.v-input--selection-controls__input:focus-visible {
  outline: 3px solid #ffbf47 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 5px rgba(0, 66, 123, 0.55) !important;
}
.v-btn:focus::before {
  opacity: 0.2 !important;
}
</style>
